<lcp-header *ngIf="fields" [isInverted]="!!fields['bannerColor']"></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <!-- <div class="main-content"> -->
    <section [ngClass]="[
        'lcp-section', 
        !!fields['bannerColor'] && 'is-banner',
        fields['bannerColor'] && 'is-background-' + fields['bannerColor']
      ]">
      <!-- [class.is-banner]="!!fields['bannerColor']"
      [style.is-background-yellow]="fields['bannerColor'] == 'yellow'"
      [style.is-background-teal]="fields['bannerColor'] == 'teal'"
      [style.is-background-red]="fields['bannerColor'] == 'red'"> -->

      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <section class="lcp-section lcp-contact-form"
      [class.is-inverted]="false">

      <div class="lcp-section-content">
        <div class="display-flex">
          <div class="flex-50-not-sm">
            <form *ngIf="form"
              class="lcp-contact-form"
              [formGroup]="form" 
              (ngSubmit)="handleSubmit()">

              <mat-form-field subscriptSizing="dynamic" appearance="outline" class="app-form-field">
                <mat-label>Your name</mat-label>
                <input matInput 
                  formControlName="name" 
                  placeholder="Enter your name"
                  [value]="form.value.name">
            
                <mat-error *ngIf="submitted && f.name.errors && f.name.errors.required"
                  >Please enter a name to continue
                </mat-error>
              </mat-form-field>

              <mat-form-field subscriptSizing="dynamic" appearance="outline" class="app-form-field">
                <mat-label>Your Email</mat-label>
                <input matInput type="text" 
                    formControlName="email" 
                    placeholder="some@email.com"
                    [value]="form.value.email" />
                    <!-- [ngClass]="{ 'is-invalid': submitted && f.email.errors }" /> -->
                <mat-error *ngIf="submitted && f.email.errors && f.email.errors.required"
                  >Email is required
                </mat-error>
                <mat-error *ngIf="submitted && f.email.errors && f.email.errors.pattern"
                  >This doesn't look like an email
                </mat-error>
              </mat-form-field>

              <mat-form-field class="app-form-field" appearance="outline">
                <mat-label>Nature of Inquiry</mat-label>
                <mat-select formControlName="message_type" 
                  #messageTypeSelect 
                  (focus)="messageTypeSelect.open()"
                  (selectionChange)="handleSelectMessageType($event)">
                  <mat-option *ngFor="let type of messageTypes" 
                    [value]="type.value"
                    (click)="messageTypeSelect.close()">
                    {{ type.display }}
                  </mat-option>
                </mat-select>

                <mat-error *ngIf="submitted && f.message_type.errors && f.message_type.errors.required"
                  >Please select an option to continue
                </mat-error>
              </mat-form-field>

              <!-- <mat-form-field subscriptSizing="dynamic" appearance="outline" class="app-form-field">
                <mat-label>Nature of Inquiry</mat-label>
                <select matInput 
                  formControlName="name" 
                  placeholder="Enter your name"
                  [value]="form.value.name">
            
                <mat-error *ngIf="submitted && f.name.errors && f.name.errors.required"
                  >Please enter a name to continue
                </mat-error>
              </mat-form-field> -->


              <mat-form-field subscriptSizing="dynamic" appearance="outline" class="app-form-field">
                <!-- <mat-label>Any additional comments?</mat-label> -->
                <textarea matInput  
                  formControlName="body" 
                  placeholder="What's on your mind?"
                  [value]="form.value.body"
                  rows="10">
                </textarea>
              </mat-form-field>

              <div class="recaptcha-container">

                <ss-recaptcha-input
                  [disabled]="isSubmitting"
                  [error]="backendErrors['recaptcha_error']"
                  (onCorrectCaptcha)="handleCorrectCaptcha($event)"
                  (onExpiredCaptcha)="handleExpiredCaptcha($event)">
                </ss-recaptcha-input>

                <!-- <mat-error *ngIf="submitted && !recaptchaResponse" -->
                <mat-error *ngIf="submitted && f.recaptcha_response.errors && f.recaptcha_response.errors.required"
                >Please complete this check to continue
                </mat-error>
              </div>

              <div class="margin-top-30">
                <button [disabled]="isLoading || isSubmitting" class="btn btn-primary flex-0">
                  Send
                </button>

                <div *ngIf="isLoading || isSubmitting" class="display-inline-block margin-left-20">
                  <mat-spinner 
                    mode="indeterminate"
                    diameter="16">
                  </mat-spinner>
                </div>

                <div *ngIf="isValid == false" class="margin-top-20">
                  <mat-error
                    >Form validation failed - please fix issues above and try again
                  </mat-error>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </section>
  </ng-container>
</div>